import { render, staticRenderFns } from "./Logiciels.vue?vue&type=template&id=79b28139"
import script from "./Logiciels.vue?vue&type=script&lang=ts"
export * from "./Logiciels.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports